import gql from "graphql-tag";

const UPDATE_790_FORM = gql`
  mutation updateForm790AById(
    $id: String!
    $Form790AFormData: Form790AFormData!
    $formUI790A: formUIInput
    $profilePrefillMetadata: [ProfilePrefillMetadataInput!]
  ) {
    updateForm790AById(
      id: $id
      Form790AFormData: $Form790AFormData
      formUI790A: $formUI790A
      profilePrefillMetadata: $profilePrefillMetadata
    )
  }
`;

const SUBMIT_790_FORM = gql`
  mutation SubmitForm790A(
    $id: String!
    $Form790AFormData: Form790AFormData!
    $token: String
  ) {
    SubmitForm790A(Form790AFormData: $Form790AFormData, id: $id, token: $token)
  }
`;

const GET_790_FORM_DATA = gql`
  query getForm790AById($id: String!) {
    getForm790AById(id: $id) {
      formVersionId
      payload {
        formVersionId
        prelim_2_employer_type
        prelim_3_is_contractor
        prelim_4_is_emergency
        prelim_5_is_livestock
        appIsItinerant
        eta_790_a13_swa_state_id
        eta_790_b1_poc_name
        eta_790_b2_poc_dba
        eta_790_b3_poc_last
        eta_790_b4_poc_first
        eta_790_b5_poc_middle
        eta_790_b6_poc_job_title
        eta_790_b7_poc_address_1
        eta_790_b8_poc_address_2
        eta_790_b9_poc_city
        eta_790_b10_poc_state_id
        eta_790_b11_poc_zip
        eta_790_b12_poc_phone
        eta_790_b13_poc_phone_ext
        eta_790_b14_poc_email
        eta_790_b14a_poc_email_addit
        eta_790_b15_poc_fein
        eta_790_b16_poc_naics
        eta_790_b16_poc_naics_description
        eta_790_c1_clearance_order_type
        eta_790a_a1_job_title
        eta_790a_a2a_workers_needed_total
        eta_790a_a2b_workers_needed_h2a
        eta_790a_a3_begin_date
        eta_790a_a4_end_date
        eta_790a_a5_is_247
        eta_790a_a6a_hours_total
        eta_790a_a6b_hours_sunday
        eta_790a_a6c_hours_monday
        eta_790a_a6d_hours_tuesday
        eta_790a_a6e_hours_wednesday
        eta_790a_a6f_hours_thursday
        eta_790a_a6g_hours_friday
        eta_790a_a6h_hours_saturday
        eta_790a_a7a_hourly_schedule_begin
        eta_790a_a7b_hourly_schedule_end
        eta_790a_a8a_job_duties
        eta_790a_a8b_wage_offer
        eta_790a_a8c_wage_offer_per
        eta_790a_a8d_piece_rate_offer
        eta_790a_a8r_piece_rate_info
        eta_790a_a9_is_addendum_a_completed
        eta_790a_a10_frequency_of_pay
        eta_790a_a10_frequency_of_pay_other
        eta_790a_b1_education_level
        eta_790a_b2_experience_months
        eta_790a_b3_training_months
        eta_790a_b4a_certification_req
        eta_790a_b4b_driver_req
        eta_790a_b4c_background_req
        eta_790a_b4d_drug_screen_req
        eta_790a_b4e_lifting_req
        eta_790a_b4f_lifting_lbs
        eta_790a_b4g_temperature_req
        eta_790a_b4h_pushing_req
        eta_790a_b4i_walking_req
        eta_790a_b4j_bending_req
        eta_790a_b4k_rep_motion_req
        eta_790a_b5a_is_supervising
        eta_790a_b5b_num_supervised
        eta_790a_b6_additional_info
        eta_790a_c1_work_address
        eta_790a_c2_work_city
        eta_790a_c3_work_state_id
        eta_790a_c4_work_zip
        eta_790a_c5_work_county_id {
          label
          value
        }
        eta_790a_c6_work_additional_info
        eta_790a_c7_is_work_addendum_b_completed
        eta_790a_d1_housing_address
        eta_790a_d2_housing_city
        eta_790a_d3_housing_state_id
        eta_790a_d4_housing_zip
        eta_790a_d5_housing_county_id {
          label
          value
        }
        eta_790a_d6_housing_type
        eta_790a_d6_housing_type_employer
        eta_790a_d6_housing_type_rental
        eta_790a_d7_housing_total_units
        eta_790a_d8_housing_total_occ
        eta_790a_d9_housing_standards
        eta_790a_d9_housing_standards_local
        eta_790a_d9_housing_standards_state
        eta_790a_d9_housing_standards_swa
        eta_790a_d9_housing_standards_other_state
        eta_790a_d9_housing_standards_other
        eta_790a_d9_housing_standards_federal
        eta_790a_d9_housing_standards_other_text
        eta_790a_d10_housing_additional_info
        eta_790a_d11_is_housing_addendum_b_completed
        eta_790a_e2a_will_not_charge
        eta_790a_e2b_will_charge
        eta_790a_e2c_meal_charge
        isMealProvision
        isDailyTransport
        isEmploymentTransport
        isPayDeductions
        eta_790a_h1_is_addendum_c_completed
        minProductivity
        isOvertimeAvailable
        addSpecialPayInfo

        eta_790a_f3a_no_less_than
        eta_790a_f3b_no_more_than
        eta_790a_g1_how_to_apply
        eta_790a_g2_apply_phone
        apply_extensions
        apply_email
        apply_url
        eta_790a_i1_last
        eta_790a_i2_first
        eta_790a_i3_middle
        eta_790a_i4_title
        eta_790a_i5_signature
        files {
          machine_name
          application_id
          FileType
          document_name
          size
          displayName
          lastModified
          state
          percentage
          document_path
        }
        eta_790a_i6_date_signed
        eta_790a_addendum_a {
          crop_id
          crop_name
          addmaCropState
          wage_per
          wage_offer
          addmaPieceRate
          additional_info
          error
        }
        agBusinesses {
          agricFein
          agricLegalName
          business_id
          agricTradeName
          agricPrevTradeName1
          agricPrevTradeName2
          agricAddress1
          agricAddress2
          agricCity
          agricState
          agricPostalCode
          agricCounty {
            label
            value
          }
          agricTotalWorkers
          error
        }
        eta_790a_addendum_b_housing {
          housing_type
          housing_type_employer
          housing_type_rental
          physical_location
          housing_address_1
          housing_address_2
          housing_city
          housing_state_id
          housing_zip
          housing_county_id {
            label
            value
          }
          additional_info
          total_units
          total_occ
          applicable_housing_standards
          applicable_housing_standards_local
          applicable_housing_standards_state
          applicable_housing_standards_swa
          applicable_housing_standards_federal
          applicable_housing_standards_other_state
          applicable_housing_standards_other
          applicable_housing_standards_other_text
          error
        }
        eta_790a_addendum_b_employment {
          legalName
          agricFeinId
          business_id
          place_of_employment
          employment_address_1
          employment_address_2
          employment_city
          employment_state_id
          employment_zip
          employment_county_id {
            label
            value
          }
          additional_info
          additionalActivity
          isAdditionalActivity
          crop_ids
          begin_date
          end_date
          error
        }
        eta_790a_addendum_c {
          section_number
          section_name
          section_details
          error
        }
      }
      form_ui {
        pages_visited
        pages_errors
      }
    }
  }
`;

const GET_790A_PROFILES = gql`
  query {
    getUserProfileInfo {
      EmployerProfiles {
        employer_id
        employer_name
      }
      EmployerPOCProfiles {
        employer_poc_id
        employer_poc_name
      }
      CropProfiles {
        crop_id
        crop_work_state
        crop_name
        crop_agricultural_activity
      }
      AgricultureProfiles {
        agriculture_id
        agriculture_name
        agriculture_emp_name
        agriculture_state
        agriculture_county
      }
      WorkerHousingProfiles {
        workerHousing_id
        workerHousing_type_of_housing
        workerHousing_state
        workerHousing_state
        workerHousing_county
        workerHousing_name
      }
      MaterialTermsProfiles {
        material_terms_id
        material_terms_profile_name
        material_terms_section_number
        material_terms_summary
        material_terms_details
      }
    }
  }
`;

export {
  GET_790_FORM_DATA,
  UPDATE_790_FORM,
  SUBMIT_790_FORM,
  GET_790A_PROFILES,
};
